/* eslint-disable camelcase */
import React from 'react';
import { graphql } from 'react-relay';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';

import { ITEMS_LIST_SORTING_DROPDOWN_KEY } from '~/modules/ecommerceProducts/components/SortingDropdown';
import withRefetchQuery from '~/modules/core/utils/relayHelpers/withRefetchQuery';
import { ITEMS_LIST_VIEW_PAGINATION_KEY } from '~/modules/coreUI/components/pagination';
import ReviewsPage from '~/modules/ecommerceCoreUI/reviews/ReviewsPage';

const ProductReviews = ({
  queryResult,
  currentUserReview,
  averageRating,
  ratingCount,
  variant_id,
  shopsLoaded,
  isLoaded,
}) => (
  <ReviewsPage
    queryResult={queryResult}
    currentUserReview={currentUserReview}
    averageRating={averageRating}
    ratingCount={ratingCount}
    variant_id={variant_id}
    shopsLoaded={shopsLoaded}
    isLoaded={isLoaded}
  />
);

ProductReviews.defaultProps = {
  queryResult: null,
  variant_id: null,
  currentUserReview: null,
  averageRating: 0,
  ratingCount: 0,
};

ProductReviews.propTypes = {
  queryResult: PropTypes.shape({}),
  currentUserReview: PropTypes.shape({}),
  averageRating: PropTypes.number,
  ratingCount: PropTypes.number,
  shopsLoaded: PropTypes.bool.isRequired,
  isLoaded: PropTypes.bool.isRequired,
  variant_id: PropTypes.string, // eslint-disable-line react/no-unused-prop-types
};

const fragment = {
  queryResult: graphql`
    fragment ProductReviews_queryResult on Query
      @argumentDefinitions(input: { type: "VariantReviewsQueryInput" }) {
        variant_reviews(input: $input) {
          related_sorts {
            display_name
            name
            selected
          }
          page_info {
            ...PaginationData_pageInfo
          }
          result {
            ref_id
            rating
            purchased_on_ayk
            review
            is_current_user
            user {
              first_name
              last_name
            }
            vendor {
              ref_id
              name
            }
            variant {
              ref_id
              root_variant_id
              options_text
            }
          }
      }
    }
  `,
};

const query = graphql`
  query ProductReviewsQuery($input: VariantReviewsQueryInput) {
    ...ProductReviews_queryResult @arguments(input: $input)
  }
`;

export default withRouter(
  withRefetchQuery(
    ProductReviews,
    query,
    fragment,
    ProductReviews,
    props => ({
      input: {
        variant_id: parseInt(props.match.params.slug.split('-')[0], 10),
        page: {
          offset: 0,
          limit: 10,
        },
      },
    }),
    {
      [ITEMS_LIST_SORTING_DROPDOWN_KEY]: {
        reset: [ITEMS_LIST_VIEW_PAGINATION_KEY],
      },
    },
    {
      sortingInfo: queryResult => _.cloneDeep(queryResult.variant_reviews.related_sorts),
      pageInfo: queryResult => _.cloneDeep(queryResult.variant_reviews.page_info),
    },
    true,
    null,
    { force: true },
  ),
);
